function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_52"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_1"
}, /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_2",
  fill: "#FFD15C",
  points: "510.93301653862,54.90861129760742 462.94568133354187,47.0732307434082 455.11026263237,1.0442638397216797 448.25546526908875,48.05288124084473 403.205233335495,54.90861129760742 448.25546526908875,61.763427734375 455.11026263237,108.77204132080078 462.94568133354187,62.743064880371094 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_3",
  fill: "#FFD15C",
  points: "123.11191058158875,1.0442638397216797 121.15353655815125,19.65215039253235 101.56692004203796,22.590184688568115 120.17387652397156,25.528226852416992 123.11191058158875,44.13519096374512 127.02959704399109,25.528226852416992 145.6374843120575,22.590184688568115 126.04995226860046,19.65215039253235 "
})), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_4",
  fill: "#CDD6E0",
  points: "96.6695659160614,60.78468704223633 91.77314257621765,27.48660945892334 86.8767192363739,60.78468704223633 54.55829119682312,65.68112182617188 86.8767192363739,71.55718231201172 91.77314257621765,104.85527801513672 96.6695659160614,71.55718231201172 130.94728350639343,65.68112182617188 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_5",
  fill: "#84DBFF",
  points: "350.32055926322937,198.87250518798828 290.5801112651825,85.26774597167969 266.09707903862,85.26774597167969 199.50090289115906,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_6",
  fill: "#54C0EB",
  points: "426.7095363140106,85.26774597167969 290.5801112651825,85.26774597167969 350.32055926322937,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_7",
  fill: "#84DBFF",
  points: "508.97461199760437,198.87250518798828 427.68918108940125,85.26774597167969 426.7095363140106,85.26774597167969 350.32055926322937,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_8",
  fill: "#F2F2F2",
  points: "275.8899257183075,471.1304397583008 350.32055926322937,198.87250518798828 199.50090289115906,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_9",
  fill: "#54C0EB",
  points: "266.09707903862,85.26774597167969 125.07121539115906,85.26774597167969 199.50090289115906,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_10",
  fill: "#84DBFF",
  points: "125.07121539115906,85.26774597167969 124.09155535697937,85.26774597167969 42.80613589286804,198.87250518798828 199.50090289115906,198.87250518798828 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_11",
  fill: "#54C0EB",
  points: "508.97461199760437,198.87250518798828 275.8899257183075,471.1304397583008 42.80613589286804,198.87250518798828 199.50090289115906,198.87250518798828 275.8899257183075,471.1304397583008 350.32055926322937,198.87250518798828 "
}), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_12"
}, /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_13",
  fill: "#FFFFFF",
  points: "350.32055926322937,168.5124740600586 346.40283465385437,193.97516632080078 319.96054339408875,197.8928451538086 346.40283465385437,201.81053924560547 350.32055926322937,229.23165130615234 354.2382228374481,201.81053924560547 380.68057513237,197.8928451538086 354.2382228374481,193.97516632080078 "
}), /*#__PURE__*/React.createElement("polygon", {
  stroke: "null",
  id: "svg_14",
  fill: "#FFFFFF",
  points: "158.36838030815125,111.71007537841797 154.45160174369812,137.17369842529297 128.00923418998718,141.0904769897461 153.47192645072937,145.0081558227539 158.36838030815125,172.43016815185547 162.28604388237,145.98783111572266 188.72839617729187,141.0904769897461 162.28604388237,137.17369842529297 "
}))), /*#__PURE__*/React.createElement("rect", {
  stroke: "#000000",
  strokeWidth: 15,
  rx: 9,
  id: "svg_185",
  height: 75.80768,
  width: 249.56523,
  y: 286.27928,
  x: 23.39132,
  fill: "#FF0C38"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), _ref);

export default __webpack_public_path__ + "static/media/minusDiamond.bb4d9e03.svg";
export { SvgComponent as ReactComponent };